/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import styled from 'styled-components';
import { ReactComponent as IconCopyright } from '../../svg/icon_dino_head.svg';

interface Props {}

const FooterStyle = styled.div`
  background: #222;
  text-align: center;
  line-height: 34px;
  p {
    padding: 0;
    font-size: 15px;
    color: #ffffff;
    display: inline-block;
    margin-right: 30px;
  }
  img {
    height: 32px;
    padding: 0 7px;
    vertical-align: middle;
  }
`;
const FooterBottom: React.FC<Props> = (props) => {
  return (
    <FooterStyle>
      <p
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 0,
          padding: 15,
        }}
      >
        <IconCopyright style={{ marginRight: 15 }} />©{new Date().getFullYear()} Dinogo.
      </p>
    </FooterStyle>
  );
};

export default FooterBottom;
